import React, { useContext, useEffect } from 'react';
import { bool, func, string, shape } from 'prop-types';

import { Overlay } from '@thd-olt-component-react/overlay';
import { SearchInput, StoreSearchContext, SuggestedAddresses } from '@thd-olt-component-react/store-search';
import { Loader } from '@thd-olt-component-react/core-ui';

import { StoreRow } from '../StoreRow/StoreRow';
import { useRentalInventoryApi } from '../../hooks/useRentalInventoryApi';
import { WarningMessage } from '../WarningMessage/WarningMessage';

import './check-nearby-stores.scss';

export const CheckNearbyStores = ({
  brandName,
  clientStore,
  imageUrl,
  opened,
  productLabel,
  rentalCategory,
  rentalSubCategory,
  toggleOpened,
  searchInput,
  // eslint-disable-next-line react/prop-types
  graphQlEnabled
}) => {

  const {
    showError,
    showLoader,
    suggestedAddresses,
    stores: storeSearchData = [],
    setServices
  } = useContext(StoreSearchContext);

  // TODO: decide if this should be used to limit the search to Rental/Load-N-Go stores
  // useEffect(() => setServices(['toolRental', 'loadNGo']), []);

  const { data: stores, loading: isLoading, error: isError } = useRentalInventoryApi({
    rentalCategory,
    rentalSubCategory,
    storeList: storeSearchData,
    graphQlEnabled
  });

  let resultsType = 'stores';
  if (suggestedAddresses?.length > 0) {
    resultsType = 'suggestedAddresses';
  } else if (showLoader || isLoading) {
    resultsType = 'loader';
  } else if (showError || isError) {
    resultsType = 'error';
  }

  const handleOverlayToggle = () => {
    toggleOpened(false);
  };

  return (
    <Overlay
      className="overlay"
      closeButton
      fit
      medium
      onClose={handleOverlayToggle}
      open={opened}
      positionedCloseButton
      scrollable={false}
    >
      <div className="overlay-container" data-component="CheckNearbyStores">
        <div className="title-bar">
          <img className="thumbnail" alt="thumbnail" src={imageUrl} height="85px" width="85" />
          <div className="title-container">
            <div className="title">{productLabel}</div>
            <div className="brand">by <span className="bold">{brandName}</span></div>
          </div>
        </div>
        <hr />
        <div className="search-bar-container">
          <div className="nearby-store-count-container">
            <>
              <div className="quantity">{storeSearchData?.length || 0}</div>
              <div className="stores-near">Store(s) near {searchInput}</div>
              <div className="carry-this">carry this tool</div>
            </>
          </div>
          <div className="search-box">
            <SearchInput />
          </div>
        </div>
        <div className="location-title-bar">
          <div className="location-text">
            This tool is available for rent today at the following locations:
          </div>
        </div>
        <hr />
        <div className="store-availability-container">
          {resultsType === 'loader' && (
            <div className="store-availability-container-loader">
              <Loader active={(showLoader || isLoading)} />
            </div>
          )}
          {resultsType === 'error' && (
            <WarningMessage
              message={
                showError ? 'We\'re sorry, but we cannot find a Home Depot Store that meets your search criteria.'
                  : 'We\'re sorry, something went wrong with checking availability. Please try again'
              }
            />
          )}
          {resultsType === 'suggestedAddresses' && (
            <SuggestedAddresses stores={suggestedAddresses} />
          )}
          {
            resultsType === 'stores' && stores
            && stores.length >= 0
            && (stores.map((store, index) => (
              <StoreRow
                clientStore={clientStore}
                key={store.storeId}
                index={index}
                store={store}
                toggleOpened={toggleOpened}
              />
            )
            ))
          }
        </div>
      </div>
    </Overlay>
  );
};

CheckNearbyStores.propTypes = {
  brandName: string.isRequired,
  searchInput: string.isRequired,
  clientStore: shape({}).isRequired,
  imageUrl: string.isRequired,
  opened: bool.isRequired,
  productLabel: string.isRequired,
  rentalCategory: string.isRequired,
  rentalSubCategory: string.isRequired,
  toggleOpened: func.isRequired
};
